import { NlpModel } from '@feedyou-ai/feedbot-schema'

export function isKbChatNlpModelProvider(model?: NlpModel): boolean {
  return model?.provider?.type === 'kb-chat'
}
